/*
 * Audit History Component
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2022 Gallagher Bassett Services, Inc.
 */

import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { take } from 'rxjs/operators';
import { AuditHistoryRecord } from 'app/shared/models';
import { AuditHistoryService } from 'app/shared/services';

@Component ( {
    selector: 'reporter-audit-history',
    templateUrl: './audit-history.component.html',
    styleUrls: ['./audit-history.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
} )
export class AuditHistoryComponent implements OnInit {
  @Input () moduleName: string;
  @Input () endpoint: string;
  @Input () createdDate: string;
  @Input () createdUserId: string;
  @Input () modifiedTs: string;
  @Input () modifiedByUserId: string;
  @Input () pageSize = 50;
  @Output () close = new EventEmitter<any> ();

  auditHistory: AuditHistoryRecord[];
  pageNumber = 1;
  totalPages = 0;
  totalRecords = 0;
  @ViewChild ( 'resultsBody', { static: false } ) resultsBody: ElementRef;
  noScrollbar: boolean;

  constructor( private service: AuditHistoryService ) {
  }

  async ngOnInit() {
    this.auditHistory = [];
    this.getHistoryPage ();
  }

  getHistoryPage() {
    this.service.get ( this.endpoint, this.pageNumber, this.pageSize ).pipe ( take ( 1 ) )
      .subscribe ( result => {
        this.auditHistory.push ( ...result.records );
        this.totalPages = result.totalPages;
        this.totalRecords = result.totalRecords;
        setTimeout ( () => {
          this.noScrollbar = this.resultsBody?.nativeElement.scrollHeight <= this.resultsBody?.nativeElement.clientHeight;
        }, 0 );
      } );
  }

  loadNextPage() {
    if ( this.pageNumber < this.totalPages ) {
      this.pageNumber++;
      this.getHistoryPage ();
    }
  }
}
